const BlogTypes = {
  RAW_TEXT: 'raw-text',
  SINGLE_IMAGE: 'single-image',
  TEXT_LIST: 'text-list',
  DATA_FEITO_POR: 'data-feito-por',
};

export default BlogTypes;
